import Loader from "./loader";
import { findIdFor } from "../stores/helpers";
import XmlDoc from "../libs/xml_doc";

const loader = new Loader();

export const showNaturalColor = async ({ view, imagery, ids }) => {
  const {
    modules: [RasterFunction]
  } = await loader.load(["esri/layers/support/RasterFunction"]);
  view.map.layers
    .filter(layer => layer.type === "imagery" && layer.title !== imagery.title)
    .forEach(layer => {
      if (ids.includes(findIdFor(layer))) {
        layer.renderingRule = new RasterFunction({
          functionName: "Color Infrared",
          outputPixelType: "U8",
          variableName: "Raster"
        });
      } else {
        layer.renderingRule = null;
      }
    });
};

export const zoomTo = async ({ view, imagery, layerId }) => {
  const {
    modules: [Polygon, Query]
  } = await loader.load(["esri/geometry/Polygon", "esri/rest/support/Query"]);
  let query = new Query();
  const outStatistics = {
    statisticType: "avg",
    onStatisticField: "MaxPS",
    outStatisticFieldName: "ZoomToOverview"
  };
  query.outStatistics = outStatistics;
  const where = `DatasetID IN (${layerId}) AND Name LIKE 'Ov_%'`;
  query.where = where;
  query.returnGeometry = true;
  let queryTask = imagery.queryTask;
  const overviewResponse = await queryTask.execute(query);
  const pixelSize = overviewResponse.features[0].attributes.ZoomToOverview;
  let queryPixel = new Query();
  queryPixel.where = where;
  queryPixel.returnGeometry = true;
  queryPixel.spatialRelationship = "intersects";
  queryPixel.geometry = Polygon.fromExtent(view.extent);
  const pixelSizeResponse = await queryTask.execute(queryPixel, {
    responseType: "json",
    query: {
      pixelSize
    }
  });

  const geometries = pixelSizeResponse.features.map(
    feature => feature.geometry
  );
  const polygons = geometries.map(
    geometry =>
      new Polygon({
        hasM: true,
        hasZ: true,
        rings: geometry.rings,
        spatialReference: geometry.spatialReference
      })
  );

  view.goTo({ target: polygons }).then(() => {
    view.zoom = view.zoom - 1;
  });
};

export const getVisibleLayersIds = async ({ view, imagery }) => {
  if (!view || !imagery) return Promise.resolve();
  const {
    modules: [Query]
  } = await loader.load(["esri/rest/support/Query"]);
  let query = new Query();
  query.outFields = ["DatasetID"];
  query.where = "NAME NOT LIKE 'Ov_%'";
  query.geometry = view.extent;
  query.returnGeometry = false;
  query.returnDistinctValues = true;
  query.spatialRelationship = "intersects";
  const { features } = await imagery.queryTask.execute(query);
  const layerIds = features.map(feature => feature.attributes.DatasetID);
  return layerIds;
};

export const queryMetadata = async ({ url, layerId }) => {
  const {
    modules: [request]
  } = await loader.load(["esri/request"]);
  const queryUrl = `${url}/info/metadata`;
  try {
    const response = await request(queryUrl, { responseType: "xml" });
    const doc = response.data;
    let xmldoc = new XmlDoc(doc);
    xmldoc.setNodeAt("metadata/dqinfo/datalineage");
    const info = xmldoc.children().find(item => {
      let childDoc = new XmlDoc(item);
      const id = parseInt(childDoc.childAt("srccitatn/resalttitle").text(), 10);
      return id === layerId;
    });
    const infoDoc = new XmlDoc(info);
    return {
      title: infoDoc.childAt("srccitatn/resTitle").text(),
      description: infoDoc.childAt("srcDesc").text(),
      link: infoDoc.childAt("srccitatn/citOnlineRes").text(),
      layerId: parseInt(infoDoc.childAt("srccitatn/resalttitle").text(), 10)
    };
  } catch (error) {
    console.log("error in query metadata: ", error);
  }
};
